import { useState } from 'react';

export default function SettingsToggle({ label, desc, defaultOn }) {
  const [on, setOn] = useState(defaultOn);
  return (
    <div className="set-row">
      <div><div className="set-l">{label}</div><div className="set-d">{desc}</div></div>
      <div className={`toggle ${on ? 'on' : ''}`} onClick={() => setOn((o) => !o)} />
    </div>
  );
}
